import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "data-follow-fill": "currentColor",
  d: "M17.636 9.5a5.642 5.642 0 0 1 3.097 7.983c-.04.073-.11.196-.213.373l.322 1.18a.705.705 0 0 1-.866.866l-1.182-.323-.137.081a5.617 5.617 0 0 1-2.897.8 5.628 5.628 0 0 1-4.292-1.98c-.412.067-.83.1-1.248.1a7.663 7.663 0 0 1-3.91-1.064l-.3-.174-1.774.477a.705.705 0 0 1-.863-.869l.48-1.735a20 20 0 0 1-.35-.601A7.411 7.411 0 0 1 2.6 11.06c0-4.155 3.414-7.52 7.62-7.52 3.524 0 6.565 2.38 7.399 5.713a.698.698 0 0 1 .017.247Zm-1.5-.308C15.324 6.7 12.95 4.95 10.22 4.95c-3.432 0-6.21 2.738-6.21 6.11a6 6 0 0 0 .731 2.88c.064.116.225.39.477.81a.705.705 0 0 1 .075.55l-.232.837.865-.232a.705.705 0 0 1 .534.07l.568.327a6.254 6.254 0 0 0 3.598.855 5.64 5.64 0 0 1 5.51-7.965Zm2.945 8.748a.703.703 0 0 1 .074-.545c.115-.191.227-.384.336-.579a4.23 4.23 0 1 0-1.559 1.635c.048-.03.182-.108.408-.239a.705.705 0 0 1 .54-.07l.277.075-.076-.277ZM8.005 9.885a.94.94 0 1 1 0-1.88.94.94 0 0 1 0 1.88Zm4.23 0a.94.94 0 1 1 0-1.88.94.94 0 0 1 0 1.88Zm1.88 4.465a.705.705 0 1 1 0-1.41.705.705 0 0 1 0 1.41Zm3.29 0a.705.705 0 1 1 0-1.41.705.705 0 0 1 0 1.41Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }